import $i18n from '@alife/panda-i18n';
import React, { useCallback, useMemo, useState } from 'react';
import { CnMessage, CnDialog } from '@alife/cn-ui';
import { affirmInfoList } from '../../const';
import { askPreChargeAndCashierUrl, cancelSelfVasItems } from '../../api';
/**
 *  交货单--增值服务 - 确认弹框
 */
export default function PublicDialog(props) {
    const { editorRecord = {}, affirmDialogVisible, setAffirmDialogVisible, closeService, setCloseService, asnCode, serviceList, // 服务项 - 数据校验
    jumpCashierUrl, setJumpCashierUrl, handleSearch, } = props;
    const [affirmVisibleLoading, setAffirmVisibleLoading] = useState(false); // 确定 - loading
    const [closeServiceLoading, setCloseServiceLoading] = useState(false); // 取消 - loading
    const onClose = useCallback(() => {
        if (affirmDialogVisible) {
            setAffirmDialogVisible(false);
        }
        else {
            setCloseService(false);
        }
    }, [affirmDialogVisible, setCloseService, setAffirmDialogVisible]);
    // 预计费金额和收银台地址
    const askPreChargeAndCashier = useCallback(async () => {
        try {
            setAffirmVisibleLoading(true);
            const res = (await askPreChargeAndCashierUrl({
                asnCode,
                vasId: editorRecord?.id,
                valueAddedServiceType: editorRecord?.selfVasType,
                valueAddedServiceTypeList: editorRecord?.valueAddedServiceTypeList,
                selfValueaddNum: editorRecord?.selfVasNum,
                selfValueaddVolume: editorRecord?.selfVasVolume,
                selfValueaddWeight: editorRecord?.selfVasWeight, //		String	否	总重量（千克）
            }));
            const { jumpCashierUrl: url, cashierUrl = '86' } = res?.data || {};
            if (url) {
                setJumpCashierUrl(url);
                window.open(cashierUrl);
            }
            setAffirmVisibleLoading(false);
            onClose();
        }
        catch (e) {
            setAffirmVisibleLoading(false);
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
            onClose();
        }
    }, [asnCode, editorRecord, onClose, setJumpCashierUrl]);
    // 获取 - 对应服务项 - 表填校验字段
    const serviceValidate = useCallback(() => {
        if (!editorRecord) {
            return;
        }
        const selService = (serviceList &&
            serviceList.find((item) => {
                return item?.value === editorRecord.selfVasType;
            })) ||
            {};
        return selService;
    }, [serviceList, editorRecord]);
    // 确认时 - 对所对应 数据进行非空校验
    const validateWay = useCallback(() => {
        const serviceVa = serviceValidate(); // 获取 - 对应服务项 - 表填校验字段
        const validate = [];
        serviceVa?.showItem?.forEach((item) => {
            if (!serviceVa.disabledItem.includes(item)) {
                validate.push(item);
            }
        });
        let errorMsg = '';
        validate.forEach((item) => {
            affirmInfoList?.forEach((msg) => {
                // 当字段相等时，取对应字段数据，
                if (item === msg.validateKey &&
                    (!editorRecord?.[msg.key] ||
                        editorRecord?.[msg.key] === '0.00' ||
                        editorRecord?.[msg.key] === '0')) {
                    errorMsg += msg.label + ', ';
                }
            });
        });
        return errorMsg;
    }, [editorRecord, serviceValidate]);
    // 结算
    const onPreCharge = useCallback(async () => {
        const errorMsg = validateWay();
        if (errorMsg) {
            CnMessage.error($i18n.get({
                id: 'PleaseEditAndFillInerrorMsg',
                dm: '请编辑并填写：{errorMsg}',
            }, { errorMsg }));
            return;
        }
        try {
            askPreChargeAndCashier(); // 跳转收银台地址
        }
        catch (e) {
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        }
    }, [askPreChargeAndCashier, validateWay]);
    // 取消
    const onCancelSelfVas = useCallback(async () => {
        try {
            setCloseServiceLoading(true);
            await cancelSelfVasItems({
                asnCode,
                vasId: editorRecord?.id,
                valueAddedServiceType: editorRecord?.selfVasType, // 增值服务类型
            });
            handleSearch();
            setCloseServiceLoading(false);
            onClose();
        }
        catch (e) {
            setCloseServiceLoading(false);
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        }
    }, [asnCode, handleSearch, editorRecord, onClose]);
    // 弹框 - 确认
    const onDialogOk = useCallback(() => {
        if (closeService) {
            onCancelSelfVas();
        }
        else {
            onPreCharge(); // 结算
        }
    }, [closeService, onCancelSelfVas, onPreCharge]);
    // 确认信息 - 提示
    const confirmData = useMemo(() => {
        return editorRecord?.selfVasTypeDesc;
    }, [editorRecord]);
    // 取消信息 - 提示
    const cancelPromptData = useMemo(() => {
        return editorRecord?.selfVasTypeDesc;
    }, [editorRecord]);
    return (React.createElement(React.Fragment, null,
        React.createElement(CnDialog, { size: 'small', className: 'ask-cashier-three affirm-info', title: $i18n.get({
                id: 'PleaseConfirmTheSettlementInformationConfirmData_375934968',
                dm: '请确认结算信息{confirmData}',
            }, { confirmData }), visible: affirmDialogVisible, footerActions: ['cancel', 'ok'], onCancel: onClose, onClose: onClose, onOk: () => onDialogOk(), closeMode: 'close', okProps: {
                loading: affirmVisibleLoading,
                disabled: affirmVisibleLoading,
            } },
            React.createElement("div", { className: 'info' },
                React.createElement("span", null, $i18n.get({
                    id: 'PleaseCheckTheFollowingInformationCarefully_433682617',
                    dm: '请仔细核对下列信息，确认后将无法修改！',
                })),
                affirmInfoList?.map((item) => {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: item?.color },
                            React.createElement("b", null,
                                item.label,
                                ":"),
                            ' ',
                            React.createElement("em", null, editorRecord?.[item.key] || '-'))));
                }))),
        React.createElement(CnDialog, { size: 'small', className: 'ask-cashier-three affirm-info', title: $i18n.get({
                id: 'IHaveCompletedTheChoiceOf_2115477924',
                dm: '我已完成支付方式的选择',
            }), visible: !!jumpCashierUrl, onOk: () => {
                setJumpCashierUrl('');
                handleSearch();
            }, footerActions: ['ok'], onCancel: () => {
                setJumpCashierUrl('');
            }, onClose: () => {
                setJumpCashierUrl('');
            }, closeMode: 'close' }),
        React.createElement(CnDialog, { className: 'ask-cashier-three affirm-info', title: $i18n.get({
                id: 'PleaseConfirmWhetherToCancelCancelPromptData_1972359484',
                dm: '请确认是否取消{cancelPromptData}',
            }, { cancelPromptData }), visible: closeService, style: { width: 400 }, footerActions: ['cancel', 'ok'], onCancel: onClose, onClose: onClose, onOk: () => onDialogOk(), closeMode: 'close', okProps: {
                loading: closeServiceLoading,
                disabled: closeServiceLoading,
            } })));
}
